import React, { FC } from 'react';
import { TextFieldProps, TextField, TextFieldSize } from '@bechtel/gds';
import { SearchFieldContainer } from './styled';
import { Icon, IconSize } from '@bechtel/gds';
import { IconProps } from './types';

type SearchIconProps = TextFieldProps & IconProps;
export const SearchField: FC<SearchIconProps> = ({ iconSize = IconSize.LARGE, ...props }) => {
  return (
    <SearchFieldContainer>
      <TextField size={TextFieldSize.MEDIUM} {...props} />
      <Icon size={iconSize} icon="search" fillColor="blue.800" />
    </SearchFieldContainer>
  );
};
